import Vue from "vue";
import Router from "vue-router";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import FoRW from "./views/FoRW.vue";
import ClubhouseinJapan from "./views/ClubhouseinJapan.vue";
import SugokuRare from "./views/SugokuRare.vue";
import ClubhouseinJapanJP from "./views/ClubhouseinJapanJP.vue";
import CannotCoachHeightJP from "./views/CannotCoachHeightJP.vue";
import TechTrendsJP from "./views/2021TechTrendsJP.vue";
import Jobs from "./views/Jobs.vue";
import privateequityjapan from "./views/privateequityjapan.vue";
import privateequityjapanJP from "./views/privateequityjapanJP.vue";
import Turbulence from "./views/Turbulence.vue";
import TurbulenceJP from "./views/TurbulenceJP.vue";
import BloggingasaRecruitingTool from "./views/BloggingasaRecruitingTool.vue";
import BloggingasaRecruitingToolJP from "./views/BloggingasaRecruitingToolJP.vue";
import WhyAUMistheWrongMetricinVC from "./views/WhyAUMistheWrongMetricinVC.vue";
import WhyAUMistheWrongMetricinVCJP from "./views/WhyAUMistheWrongMetricinVCJP.vue";
import WhyITendtoPreferEquityRoundsOverNotes from "./views/WhyITendtoPreferEquityRoundsOverNotes.vue";
import WhyITendtoPreferEquityRoundsOverNotesJP from "./views/WhyITendtoPreferEquityRoundsOverNotesJP.vue";
import LeadVC from "./views/LeadVC.vue";
import LeadVCJP from "./views/LeadVCJP.vue";
import DueDiligenceTrap from "./views/DueDiligenceTrap.vue";
import DueDiligenceTrapJP from "./views/DueDiligenceTrapJP.vue";
import JapanMA from "./views/JapanMA.vue";
import JapanMAJP from "./views/JapanMAJP.vue";
import Sprout from "./views/Sprout.vue";
import SproutJP from "./views/SproutJP.vue";
import VCRadar2023 from "./views/VCRadar2023.vue";
import VCRadar2023JP from "./views/VCRadar2023JP.vue";
import VCMath from "./views/VCMath.vue";
import VCMathJP from "./views/VCMathJP.vue";
import HowToPitchUs from "./views/HowToPitchUs.vue";
import HowToPitchUsJP from "./views/HowToPitchUsJP.vue";
import FranceInnovationRenaissance from "./views/FranceInnovationRenaissance.vue";
import FranceInnovationRenaissanceJP from "./views/FranceInnovationRenaissanceJP.vue";
import SweetSpot from "./views/SweetSpot.vue";
import SweetSpotJP from "./views/SweetSpotJP.vue";
import About from "./views/About";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: Header,
        default: Landing,
        footer: Footer
      }
    },
    {
      path: "/components",
      name: "components",
      components: {
        header: Header,
        default: Components,
        footer: Footer
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: Header,
        default: Landing,
        footer: Footer
      }
    },
    {
      path: "/perspectives/futureofremotework",
      name: "futureofremotework",
      components: {
        header: Header,
        default: FoRW,
        footer: Footer
      }
    },
    {
      path: "/perspectives/sugokurare",
      name: "sugokurare",
      components: {
        header: Header,
        default: SugokuRare,
        footer: Footer
      }
    },
    {
      path: "/perspectives/clubhouseinjapan",
      name: "clubhouseinjapan",
      components: {
        header: Header,
        default: ClubhouseinJapan,
        footer: Footer
      }
    },
    {
      path: "/jobs",
      name: "jobs",
      components: {
        header: Header,
        default: Jobs,
        footer: Footer
      }
    },
    {
      path: "/perspectives/clubhouseinjapanjp",
      name: "clubhouseinjapanjp",
      components: {
        header: Header,
        default: ClubhouseinJapanJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/cannotcoachheightjp",
      name: "cannotcoachheightjp",
      components: {
        header: Header,
        default: CannotCoachHeightJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/2021techtrendsjp",
      name: "2021techtrendsjp",
      components: {
        header: Header,
        default: TechTrendsJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/bloggingasarecruitingtool",
      name: "bloggingasarecruitingtool",
      components: {
        header: Header,
        default: BloggingasaRecruitingTool,
        footer: Footer
      }
    },
    {
      path: "/perspectives/bloggingasarecruitingtooljp",
      name: "bloggingasarecruitingtooljp",
      components: {
        header: Header,
        default: BloggingasaRecruitingToolJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/whyaumisthewrongmetricinvc",
      name: "whyaumisthewrongmetricinvc",
      components: {
        header: Header,
        default: WhyAUMistheWrongMetricinVC,
        footer: Footer
      }
    },
    {
      path: "/perspectives/whyaumisthewrongmetricinvcjp",
      name: "whyaumisthewrongmetricinvcjp",
      components: {
        header: Header,
        default: WhyAUMistheWrongMetricinVCJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/whyitendtopreferequityroundsovernotes",
      name: "whyitendtopreferequityroundsovernotes",
      components: {
        header: Header,
        default: WhyITendtoPreferEquityRoundsOverNotes,
        footer: Footer
      }
    },
    {
      path: "/perspectives/whyitendtopreferequityroundsovernotesjp",
      name: "whyitendtopreferequityroundsovernotesjp",
      components: {
        header: Header,
        default: WhyITendtoPreferEquityRoundsOverNotesJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/privateequityjapan",
      name: "privateequityjapan",
      components: {
        header: Header,
        default: privateequityjapan,
        footer: Footer
      }
    },
    {
      path: "/perspectives/privateequityjapanjp",
      name: "privateequityjapanjp",
      components: {
        header: Header,
        default: privateequityjapanJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/turbulence",
      name: "turbulence",
      components: {
        header: Header,
        default: Turbulence,
        footer: Footer
      }
    },
    {
      path: "/perspectives/turbulencejp",
      name: "turbulencejp",
      components: {
        header: Header,
        default: TurbulenceJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/LeadVC",
      name: "LeadVC",
      components: {
        header: Header,
        default: LeadVC,
        footer: Footer
      }
    },
    {
      path: "/perspectives/LeadVCJP",
      name: "LeadVCJP",
      components: {
        header: Header,
        default: LeadVCJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/DueDiligenceTrap",
      name: "DueDiligenceTrap",
      components: {
        header: Header,
        default: DueDiligenceTrap,
        footer: Footer
      }
    },
    {
      path: "/perspectives/DueDiligenceTrapJP",
      name: "DueDiligenceTrapJP",
      components: {
        header: Header,
        default: DueDiligenceTrapJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/JapanMA",
      name: "JapanMA",
      components: {
        header: Header,
        default: JapanMA,
        footer: Footer
      }
    },
    {
      path: "/perspectives/JapanMAJP",
      name: "JapanMAJP",
      components: {
        header: Header,
        default: JapanMAJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/Sprout",
      name: "Sprout",
      components: {
        header: Header,
        default: Sprout,
        footer: Footer
      }
    },
    {
      path: "/perspectives/SproutJP",
      name: "SproutJP",
      components: {
        header: Header,
        default: SproutJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/FranceInnovationRenaissance",
      name: "FranceInnovationRenaissance",
      components: {
        header: Header,
        default: FranceInnovationRenaissance,
        footer: Footer
      }
    },
    {
      path: "/perspectives/FranceInnovationRenaissanceJP",
      name: "FranceInnovationRenaissanceJP",
      components: {
        header: Header,
        default: FranceInnovationRenaissanceJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/SweetSpot",
      name: "SweetSpot",
      components: {
        header: Header,
        default: SweetSpot,
        footer: Footer
      }
    },
    {
      path: "/perspectives/SweetSpotJP",
      name: "SweetSpotJP",
      components: {
        header: Header,
        default: SweetSpotJP,
        footer: Footer
      }    
    },
    {
        path: "/perspectives/HowToPitchUs",
        name: "HowToPitchUs",
        components: {
          header: Header,
          default: HowToPitchUs,
          footer: Footer
        }
    },
    {
        path: "/perspectives/HowToPitchUsJP",
        name: "HowToPitchUsJP",
        components: {
          header: Header,
          default: HowToPitchUsJP,
          footer: Footer
        }
    },
    {
      path: "/perspectives/VCMath",
      name: "VCMath",
      components: {
        header: Header,
        default: VCMath,
        footer: Footer
      }
    },
    {
      path: "/perspectives/VCMathJP",
      name: "VCMathJP",
      components: {
        header: Header,
        default: VCMathJP,
        footer: Footer
      }
    },
    {
      path: "/perspectives/VCRadar2023",
      name: "VCRadar2023",
      components: {
        header: Header,
        default: VCRadar2023,
        footer: Footer
      }
    },
    {
      path: "/perspectives/VCRadar2023JP",
      name: "VCRadar2023JP",
      components: {
        header: Header,
        default: VCRadar2023JP,
        footer: Footer
      }
    },
    {
      path: '/about',
      name: 'about',
      components: {
        header: Header,
        default: About,
        footer: Footer,
      }
    },
    {
      path: "/perspectives/VCRadar2023",
      name: "VCRadar2023",
      components: {
        header: Header,
        default: VCRadar2023,
        footer: Footer
      }
    },
    {
      path: "/perspectives/VCRadar2023JP",
      name: "VCRadar2023JP",
      components: {
        header: Header,
        default: VCRadar2023JP,
        footer: Footer
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
